import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@store";

export const GET_LIST_AGENCIES = "GET_LIST_AGENCIES";

interface listAgenciesResponse {
  data?: any;
  loading?: boolean;
  error?: any;
}

interface responseType {
  getListAgenciesResponse?: listAgenciesResponse;
}

const initialState: responseType = {
  getListAgenciesResponse: { data: null, error: null, loading: false },
};

export const ListAgenciesSlice = createSlice({
  name: "listAgencies",
  initialState,
  reducers: {
    getListAgenciesStart: (state) => {
      state.getListAgenciesResponse = { data: null, error: null, loading: true };
    },
    getListAgenciesSuccess: (state, action: PayloadAction<any>) => {
      state.getListAgenciesResponse = { data: action.payload, error: null, loading: false };
    },
    getListAgenciesError: (state, action: PayloadAction<any>) => {
      state.getListAgenciesResponse = { data: null, error: action.payload, loading: false };
    },
    resetGetListAgencies: (state) => {
      state.getListAgenciesResponse = { data: null, error: null, loading: false };
    },
  },
});

export const {
  getListAgenciesError,
  getListAgenciesStart,
  getListAgenciesSuccess,
  resetGetListAgencies,
} = ListAgenciesSlice.actions;

export const ListAgenciesStore = (state: RootState) => state.listAgenciesSaga;

export default ListAgenciesSlice.reducer;
